/**
 * Guest provenance — how a guest entered the system. Stamped server-side and
 * returned on the GuestDTO. Null on legacy guests (rendered as "Unknown" via
 * the is-empty `∅` filter operator, no enum member).
 *
 * `IMPORT_CSV` additionally carries an {@link Guest.importId} linking to a
 * durable import-batch row (see ImportBatch + GET /guests/{eventId}/imports).
 */
export enum GuestOrigin {
  IMPORT_CSV = "IMPORT_CSV",
  ADMIN_MANUAL = "ADMIN_MANUAL",
  AI = "AI",
  PUBLIC_REGISTRATION = "PUBLIC_REGISTRATION",
  COMPANION_REQUEST = "COMPANION_REQUEST",
  DEMO = "DEMO",
  /**
   * Copied into the event from the company CRM contact pool ("Add from CRM").
   * The guest additionally carries a `contactId` backlink.
   * i18n: the display label lives with the other origin option labels
   * (optionsMultiSingleSelect `origin` values in en-US.json) — added in the
   * CRM i18n phase (F6), not here.
   */
  CRM = "CRM",
  /**
   * Copied server-side from another event's guest list (duplicate-with-guests
   * or template-apply with a source event). Per-event state was reset at copy
   * time; `contactId` carries over when the source guest had one.
   */
  CLONED = "CLONED",
  /**
   * Added at the door by the check-in app (a walk-up companion). Backend-only
   * until now: the enum was missing the value, so `optionsMap` — built from
   * `Object.values(GuestOrigin)` — had no entry and the guest-list column plus
   * the popup's display-only cell printed the raw string `CHECKIN_APP`.
   */
  CHECKIN_APP = "CHECKIN_APP",
  /** Promoted from an event speaker (`POST /event-speakers/…/promote`). Same
   *  story as CHECKIN_APP — pinned now by the GuestOrigin parity test. */
  SPEAKER = "SPEAKER",
}
